<template>
  <div id="app">
    <div id="appArea">
      <b-navbar type="dark" variant="cerceve-navbar" fixed="top">
        <b-container fluid >
          <b-container>
                <b-navbar-brand href="#">cercev-e | arena</b-navbar-brand>
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-nav-item href="#"><v-icon name="brands/linkedin-in" /></b-nav-item>
                    <b-nav-item href="#"><v-icon name="brands/facebook-f" /></b-nav-item>
                    <b-nav-item href="#"><v-icon name="brands/youtube" /></b-nav-item>
                    <b-nav-item href="#"><v-icon name="brands/instagram" /></b-nav-item>
                  </b-nav-form>
                </b-navbar-nav>
          </b-container>
        </b-container>
      </b-navbar>

      <b-container>
        <b-row>
          <b-col cols="9">
            <b-card no-body>
              <b-tabs v-model="tabIndex" pills small card>
                <b-tab>
                  <template v-slot:title>
                    <v-icon name="tools"/> Arıza Takibi
                  </template>
                  <ServiceFormForm ref="ServiceFormForm" @QueryRequest="addQueryHistory" @QueryResponse="handleServiceFormQueryResponse" />
                  <ServiceFormView :data=ServiceFormQueryData @SearchByFormNo="reQueryHistoryItem"/>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <v-icon name="award"/> Garanti Takibi
                  </template>
                  <ProductCheckForm ref="ProductCheckForm" @QueryRequest="addQueryHistory" @QueryResponse="handleProductCheckQueryResponse" />
                  <ProductCheckView :data=ProductCheckQueryData />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <v-icon name="shipping-fast"/> Sipariş Takibi
                  </template>
                  <OrderStatusForm ref="OrderStatusForm" @QueryRequest="addQueryHistory" @QueryResponse="handleOrderStatusQueryResponse" />
                  <OrderStatusView :data=OrderStatusQueryData />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <v-icon name="cloud-download-alt"/> Formlar
                  </template>
                  <FormsView />
                </b-tab>
              </b-tabs>
            </b-card>
          </b-col>
          <b-col cols="3">
            <QueryHistory :data=QueryHistoryData @RemoveHistoryItem="removeQueryHistory" @ReQueryHistoryItem="reQueryHistoryItem"/>
          </b-col>
        </b-row>
        <b-row class="mt-5 mb-4">
          <b-col cols="5">
            <h6 class="text-muted"><small>cercev-e.com bir <strong>Arena Open</strong> hizmetidir.</small></h6>
          </b-col>
          <b-col cols="4" class="text-right">
            <h6 class="text-muted"><small>Yasal Uyarı | Gizlilik Politikası</small></h6>
          </b-col>      
          <b-col cols="3" class="text-center">
            <h6 class="text-muted"><small>Arena Bilgisayar A.Ş. | 0 212 364 67 00</small></h6>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div id="printArea">
      <ul class="printContent">
        <li></li>
        <li class="logo"><img src="@/assets/arena.png" width="179" height="50" /></li>
        <li></li>
        <li></li>
        <li>
          <table width="100%">
            <tr>
              <td width="30%"><b>Konu :</b> Değişim / İade Belgesi</td>
              <td width="40%"></td>
              <td width="30%"><b>Belge Tarihi :</b> [{BELGE_TARIHI}]</td>
            </tr>
            <tr>
              <td width="30%"><b>Referans No :</b> [{REFERANS_NO}]</td>
              <td width="40%"></td>
              <td width="30%"><b>İade Onay Tarihi :</b> [{IADE_ONAY_TARIHI}]</td>
            </tr>
          </table>
        </li>
        <li>
          <ul>
            <li>Teknik Servisimize ulaştırmış olduğunuz aşağıda detayları yazılı cihazınızın tamiri mümkün olmadığından müşteri memnuniyeti  anlayışımız kapsamında ürününüz için değişim / iade hakkı tanınmıştır.</li>
            <li></li>
            <li>Bu Değişim  / iade Belgesi ve Satış Faturanızın orijinali ile birlikte urunu satın aldığınız firmaya başvurarak  degişim / iade işlemlerini gerçekleştirebilirsiniz.</li>
            <li></li>
            <li><b>İş bu Değişim Belgesi 30 gün geçerlidir!</b></li>
            <li></li>
            <li>Arena Bilgisayar San Ve Tic. A.Ş. - 0212 3646700</li>
          </ul>
        </li>
        <li></li>
        <li><b>Ürün Bilgileri</b></li>
        <li>
          <ul>
            <li><b>İthalatçı Firma 			:</b> Arena Bilgisayar San Ve Tic. A.Ş</li>
            <li><b>Belge No					:</b> [{BELGE_NO}]</li>
            <li><b>Ürün Modeli				:</b> [{URUN_MODELI}]</li>
            <li><b>İmei / Seri No			:</b> [{SERINO}]</li>
            <li><b>Tüketici Adı				:</b> [{MUSTERI_ADI}]</li>
            <li><b>Telefon No				:</b> [{MUSTERI_TELEFON}]</li>
            <li><b>Değişim/İade Onay tarihi	:</b> [{ONAY_TARIHI}]</li>
          </ul>
        </li>
        <li></li>
        <li></li>
        <li>
          <b>Satıcı Firmanın Dikkatine :</b>
          <ul style="margin:25px;">
            <li>Ürüne ücret iadesi veya değişim işlemlerini yapmadan önce http://www.cercev-e.com adlı sitemizden ürünün bilgilerini ve durumunu (İade faturasının beklendiğini) kontrol ederek işlem yapınız.</li>
            <li>Arızalı ürün, iade işlemi tamamlanana kadar Arena Bilgisayar A.Ş. Teknik servisinde kalacak olup, Son kullanıcıya ürün değişim veya ücret iadeişlemini yaptıktan sonra bu belgeyle birlikte iade faturanızı keserek servisimize ulaştırmanız gerekmektedir.</li>
            <li>Değişim/İade işlemlerinin uygulanması konusunda çıkabilecek ihtilaflarda ithalatçı firmanın onayına başvurulmalıdır.</li>
          </ul>
        </li>
        <li></li>
        <li></li>
        <li class="redText">
          <b>ÖNEMLİ :</b>
          <ul style="margin:25px;">
            <li>Ürünün Arena Bilgisayar tarafından iade kabul edilmesi için bu iade formunun Islak imzalı olmasına gerek yoktur.</li>
            <li>Kullanıcıya ücret iadesi işlemleri başlattığınızda; tarafımızdan mükerrer olarak işlemi yapılmaması için mutlaka <u>Musteri.Hizmetleri@arena.com.tr</u> e-mail adresinden onay alınması gerekmektedir.</li>
            <li>E-mail ile ücret iadesi onayı alınmaması halinde, ürün iade faturası kabul edilmeyecektir.</li>
          </ul>
        </li>
        <li></li>
        <li><b>Arena Bilgisayar San.Ve Tic. A.Ş.</b></li>
        <li>Teknik Servis</li>
      </ul>
    </div>
  </div>
</template>

<script>

import OrderStatusForm from './components/OrderStatusForm.vue'
import OrderStatusView from './components/OrderStatusView.vue'

import ProductCheckForm from './components/ProductCheckForm.vue'
import ProductCheckView from './components/ProductCheckView.vue'

import ServiceFormForm from './components/ServiceFormForm.vue'
import ServiceFormView from './components/ServiceFormView.vue'

import FormsView from './components/FormsView.vue'

import QueryHistory from './components/QueryHistory.vue'

export default {
  name: 'App',
  components: {
    OrderStatusForm,
    OrderStatusView,
    ProductCheckForm,
    ProductCheckView,
    ServiceFormForm,
    ServiceFormView,
    FormsView,
    QueryHistory
  },
  data() {

    const params = new Proxy(
      new URLSearchParams(window.location.search), 
      {
        get: (searchParams, prop) => searchParams.get(prop),
      }
    );

    var tabIndex = params.im || params.pc ? 3 : 0;
    return {
      tabIndex: tabIndex,
      OrderStatusQueryData: null,
      ProductCheckQueryData: null,
      ServiceFormQueryData: null,
      QueryHistoryData: []
    }
  },
  mounted() {
    if (localStorage.QueryHistoryData) {
      this.QueryHistoryData = JSON.parse(localStorage.QueryHistoryData);
    }

    window.addEventListener("beforeunload", function (e) {
      var confirmationMessage = "Uygulamadan ayrılmak istediğinize emin misiniz?";

      (e || window.event).returnValue = confirmationMessage;     // Gecko + IE
      return confirmationMessage;                                /* Safari, Chrome, and other
                                                                  * WebKit-derived browsers */
    });


  },
  watch: {
    QueryHistoryData(data) {
      localStorage.QueryHistoryData = JSON.stringify(data);
    }
  },
  methods: {
    backbuttonCallBackFunction()
    {
      alert('test');
    },
    addQueryHistory(queryArgs)
    {
      var x = this.QueryHistoryData.find(function(element) {
        return element.from === queryArgs.from && element.query === queryArgs.query
      });
      if(x === undefined || x === null) {      
        if(this.QueryHistoryData.length == 10)
          this.QueryHistoryData.pop();
        this.QueryHistoryData.unshift(queryArgs);
      }

    },
    removeQueryHistory(item) {
      const index = this.QueryHistoryData.indexOf(item);
      if (index > -1) {
        this.QueryHistoryData.splice(index, 1);
      }
    },
    reQueryHistoryItem(item) {
      this.tabIndex = item.tabIndex;
      this.$refs[item.from].query = item.query;
      this.$refs[item.from].handleQuery();
    },
    handleOrderStatusQueryResponse(response) {
      this.OrderStatusQueryData = response;
    },
    handleProductCheckQueryResponse(response) {
      this.ProductCheckQueryData = response;
    },
    handleServiceFormQueryResponse(response) {
      this.ServiceFormQueryData = response;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 86px;
}
.table.b-table.b-table-stacked > tbody > tr > [data-label]::before  {
    text-align: left;
}

.bg-cerceve-navbar { background-color: #FEF9F1; }
.bg-cerceve-navbar .navbar-brand { color: #ED9D25; }
.bg-cerceve-navbar .navbar-brand:focus { color: #ED9D25; }
.bg-cerceve-navbar .navbar-brand:hover { color: #ED9D25; }

.bg-cerceve-navbar .navbar-nav .nav-link { color: #271903; }

.bg-cerceve-navbar .navbar-nav .nav-link:focus { color: #271903; }
.bg-cerceve-navbar .navbar-nav .nav-link:hover { color: #ED9D25; }

.card-header { background-color: #fff;}
.nav-pills .nav-link { color: #212529; }
.nav-pills .nav-link.active { background: #ED9D25;}
.nav-pills .nav-link .fa-icon { margin-right: 3px; }

.historyItemDelete .fa-icon{ color: #ced4da; }
.historyItemDelete .fa-icon:hover { color: #ED9D25; }

.historyItem { color: #8A8A8A; }
.historyItem:hover { text-decoration: none; color: #ED9D25; }
.historyItem .fa-icon { margin-right: 3px; color: #8A8A8A; }
.historyItem:hover .fa-icon { color: #ED9D25; }

.btn-info { background-color: #F4C073; border-color: #F4C073;}
.btn-info:hover { background-color: #ED9D25; border-color: #ED9D25;}
.btn-info:focus { background-color: #ED9D25; border-color: #ED9D25; box-shadow: 0 0 0 0.2rem rgba(239,164,55,.25);}
.btn-info:not(:disabled):not(.disabled).active, .btn-info:not(:disabled):not(.disabled):active
 { background-color: #ED9D25; border-color: #ED9D25;}
.form-control:focus { border-color: #ced4da; box-shadow: 0 0 0 0.2rem rgba(239,164,55,.25);}
.btn-info:not(:disabled):not(.disabled).click, .btn-info:not(:disabled):not(.disabled):click
 { background-color: #ED9D25; border-color: #ED9D25;}

.bg-danger {background-color: #8A8A8A !important;}


.form-control.is-invalid:focus { border-color: #F4C073; box-shadow: 0 0 0 0.2rem rgba(239,164,55,.25); }
.form-control.is-valid:focus { border-color: #ced4da; box-shadow: 0 0 0 0.2rem rgba(239,164,55,.25); }

.form-control.is-invalid { border-color: #F4C073;  }
.form-control.is-valid { border-color: #ced4da;  }

@media print
{
    body
    {
        font-family: Arial, Verdana, "Times New Roman";
        background-image: none;
        background-color: #FFF;
        height: auto;
        text-align: left;
    }
    #header,
    #appArea
    {
        display: none;
    }
    #printArea
    {
        display: block !important;
    }
}
.redText 
{
  color: red !important;
}
#printArea
{
    display:none;
}
#printArea ul,
#printArea ul li,
#printArea ul li ul,
#printArea ul li ul li
{
    margin:0;
    padding: 0;
    text-indent: 0;
    list-style-type: 0;
    text-align: left;
}

#printArea ul li.logo
{
    text-align: center;
}
</style>
